import { Injectable, OnDestroy } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './auth.service';
import { environment } from 'src/app/environments/environment';
@Injectable()
export class AuthInterceptor implements HttpInterceptor, OnDestroy {
  private databaseKey: any = environment.servralUrl;
  private excludedRoutes: string[] = [
    '/api/auth/signin',
    '/api/v1/me/login-audit/device-info',
    '/api/v1/auth-settings/login',
    '/api/auth/forgetPassword',
    '/api/v1/reset-password',
    '/api/v1/forgot-password-link',
    '/api/v1/changePassword',
    'api/v1/forgotSendOtp',
    '/api/v1/forgotPassword',
    '/api/v1/get_candidate_companyDetails',
    '/api/v1/getActiveStatus',
    '/api/v1/get_all_selfratings',
    '/api/v1/create_company_quality_ratings',
    '/api/v1/unsubcribeEmail',
    '/api/v1/getCandidateoffer_detailsBYID/:id',
    '/api/v1/download_offer_letter/:id',
    '/api/v1/updateCandidate_OfferStatus',
    '/api/v1/getAll_job_descripition/:id',
    '/api/v1/createjob_email/:id',
    '/api/v1/getAll_Country_codes',
    "/documents",
    "/api/v1/createjob_email",
    "/api/v1/get_user_selection_answer/:id",
    '/api/v1/submit_employer_details',
    '/api/v1/getcandiate_detailsBYID/:id',
    "/api/v1/upload_candidate_documents",
    "/api/v1/get_candidate_documents_by_candidate_id",
    "/api/v1/branchSetup_get_active",
    "/api/v1/getactive_employmentTypeList",
    "/api/v1/getAll_segment",
    "/api/v1/getAll_Entity",
    "/api/v1/gradelist",
    "/api/v1/getAllDepartment",
    "/api/v1/getAllDesignation",
    "/api/v1/getAll_new_region",
    "/api/auth/registrationall",
    "/api/v1/employmentlist",
    "/api/v1/plant_getAll",
    "/api/v1/getAllArea_active",
    "/api/v1/getAllcountry",
    "/api/v1/get_Municipality/:id",
    "/api/v1/getAllDesignation_active",
    "/api/v1/getCandidate_detailsByID/:id",
    "/api/v1/check_candidate_as_user",
    "/api/auth/userbyid/:id",
    "/api/auth/generateEmpCode",
    "/api/v1/register_onboarded_employee",
    "/api/v1/getAllBrand",
    "/api/v1/getAlllocation",
    "/api/v1/officeLocationall",
    "/api/v1/getstatesbycountryid",
    "/api/v1/getstatesbycountryid/:id",
    "/api/v1/getcitybystateid",
    "/api/v1/getcitybystateid/:id",
    "/api/v1/register_onboarded_employee",
    "/api/v1/getAll_Active_BANK",
    "/api/v1/getAllDepartment_all_active",
    "/api/v1/download_uploaded_documents/:travel_id",
    "/api/v1/downloadUploadTicketbucket/:travel_id",
    "/api/v1/get_day_data_by_quot_id",
    "/api/v1/get_quotation_byId",
    "/api/v1/userDetails",
    "/api/v1/entityDetails",
    "/api/v1/createQuestions",
    "/api/v1/addFeedback",
    "/api/getAllQuotationVersions",
    "/api/getQuotationVersiondetailsIdWise",
    "/api/v1/email-preview/:id",
    "/api/v1/updateEmployeeStatus/:id",
    "/api/V1/feedback/validate/:token",
    "/api/v1/feedback/submit/:token",
    '/api/v1/contact-us',
    "/api/V2/get_Global_JD",
    "/api/v1/getuser_details_ByID/:employee_id",
    "/api/v1/updateInternshipReview",
    // Google Maps / Places APIs — use X-Goog-Api-Key / script key, not Bearer
    'places.googleapis.com',
    'maps.googleapis.com',
    'api.ipify.org',
  ];

  private tokenCheckInterval: any;
  private intervalStarted = false;
  warningShown: boolean = false;
  private isClearingSession: boolean = false;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private authService: AuthService,
    private http: HttpClient
  ) { }

  matchRoute(pattern: any, path: any) {
    const regex = new RegExp('^' + pattern.replace(/:[^/]+/g, '[^/]+') + '$');
    return regex.test(path);
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const shouldBypass = this.excludedRoutes.some(
      (route) => {
        return request.url.includes(route) || this.matchRoute(`${this.databaseKey}${route}`, request.url)

      }
    );
    if (shouldBypass) {
      return next.handle(request);
    }
    const signIn = localStorage.getItem('loginUserDetails');
    const signInUser = signIn ? JSON.parse(signIn) : null;

    if (
      !signInUser ||
      !signInUser.accessToken ||
      this.isTokenExpired(signInUser.accessToken)
    ) {
      // Request already carries Bearer (e.g. post-login audit enrich) — do not clear session.
      if (request.headers.has('Authorization')) {
        return next.handle(request);
      }
      if (!this.isClearingSession) {
        this.clearSession();
      }
      return throwError(() => new Error('Token missing or expired'));
    }
    if (!this.intervalStarted) {
      this.startTokenExpirationWatcher(signInUser?.accessToken);
    }

    const modifiedReq = request.clone({
      setHeaders: {
        Authorization: `Bearer ${signInUser?.accessToken}`,
      },
    });

    return next.handle(modifiedReq).pipe(
      catchError((error) => {
        if (error?.status === 401 && !this.isClearingSession) {
          this.clearSession();
        }
        return throwError(() => error);
      })
    );
  }

  private startTokenExpirationWatcher(token: string): void {
    this.intervalStarted = true;

    const payload = JSON.parse(atob(token.split('.')[1]));
    const expiry = payload.exp; // Token expiration time in seconds
    const warningThreshold = expiry - 120; // 2 minutes before expiry

    this.tokenCheckInterval = setInterval(() => {
      const now = Math.floor(Date.now() / 1000); // current time in seconds

      // Show warning 2 minutes before expiry
      if (now >= warningThreshold && now < expiry && !this.warningShown) {
        this.warningShown = true;
        this.toastr.warning(
          'Your session will expire in 2 minutes. Please save your work.',
          'Session Warning'
        );
      }

      // If token is expired
      if (now >= expiry) {
        this.clearSession();
      }
    }, 5000); // check every 5 seconds
  }

  private isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const expiry = payload.exp;
      const now = Math.floor(Date.now() / 1000);
      return now >= expiry;
    } catch (e) {
      return true;
    }
  }

  private clearSession(): void {
    if (this.isClearingSession) {
      return; // Prevent recursive calls
    }   
    this.isClearingSession = true;
    clearInterval(this.tokenCheckInterval);
    this.intervalStarted = false;
    this.warningShown = false;

    // Get employee ID from localStorage before clearing
    const signIn = localStorage.getItem('loginUserDetails');
    const signInUser = signIn ? JSON.parse(signIn) : null;
    const employeeId = signInUser?.employee_id;

    // Update employee status before logout
    if (employeeId) {
      const statusData = {
        status: 'INACTIVE'
      };
      
      this.http.put(
        `${this.databaseKey}/api/v1/updateEmployeeStatus/${employeeId}`,
        statusData
      ).subscribe({
        next: (response) => {
          
          // Navigate to login after status update
          this.navigateToLogin();
        },
        error: (error) => {
          // Navigate to login even if status update fails
          this.navigateToLogin();
        }
      });
    } else {
      // If no employee ID, navigate directly
      this.navigateToLogin();
    }
  }
  private navigateToLogin(): void {
    // Clear localStorage
    localStorage.removeItem('loginUserDetails');
    localStorage.removeItem('signInUser');
    localStorage.clear();
    
    // Show error message
    this.toastr.error(
      'Session expired. Please login again.',
      'Authentication Error'
    );
    
    // Navigate to login page
    this.router.navigate(['/auth/login']).then(() => {
      // Reset the flag after navigation
      this.isClearingSession = false;
    });
  }

  ngOnDestroy(): void {
    clearInterval(this.tokenCheckInterval);
  }
}
